import { z } from 'zod'
import { Model } from '../../_kernel/architecture'
import { Language } from '../../shared/domain/Language'
import { Slug } from '../../_kernel/Slug'
import { Market } from '../../shared/domain/Market'
import { Promotion } from './Promotion'
import { GETCurrentPromoMarketingResponse } from '../infrastructure/HTTPMarketingRepository/schemas/promotions/active'

export const ListOfPromotionValidation = z.object({
  list: z.instanceof(Promotion, { message: '[ListOfPromotion] list is required' }).array(),
})

export class ListOfPromotion extends Model {
  static create({ list }: z.infer<typeof ListOfPromotionValidation>) {
    ListOfPromotionValidation.parse({ list })
    return new ListOfPromotion(list)
  }

  static empty() {
    return new ListOfPromotion([])
  }

  static fromAPI({
    json,
    market,
    language,
  }: {
    json: GETCurrentPromoMarketingResponse
    market: Market
    language: Language
  }) {
    if (!json) {
      return ListOfPromotion.empty()
    }

    return ListOfPromotion.create({
      list: json.map(promo => Promotion.fromAPI({ json: promo, market, language })),
    })
  }

  constructor(private readonly _list: Promotion[]) {
    super()
  }

  get list() { return this._list } // prettier-ignore

  findById({ id }: { id: Slug }) {
    return this._list.find(promotion => promotion.id === id.value)
  }

  getFirstOrEmpty() {
    return this._list[0] ?? Promotion.empty()
  }

  toJSON() {
    return { list: this._list.map(item => item.toJSON()) }
  }
}
